import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const LeistungenPage = lazy(() => import('../pages/leistungen/page'));
const HausmeisterPage = lazy(() => import('../pages/hausmeister/page'));
const SchluesseldienPage = lazy(() => import('../pages/schluesseldienst/page'));
const JobsPage = lazy(() => import('../pages/jobs/page'));
const KontaktPage = lazy(() => import('../pages/kontakt/page'));
const ImpressumPage = lazy(() => import('../pages/impressum/page'));
const DatenschutzPage = lazy(() => import('../pages/datenschutz/page'));
const AGBPage = lazy(() => import('../pages/agb/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));
const DankePage = lazy(() => import('../pages/danke/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/leistungen',
    element: <LeistungenPage />,
  },
  {
    path: '/hausmeister',
    element: <HausmeisterPage />,
  },
  {
    path: '/schluesseldienst',
    element: <SchluesseldienPage />,
  },
  {
    path: '/jobs',
    element: <JobsPage />,
  },
  {
    path: '/kontakt',
    element: <KontaktPage />,
  },
  {
    path: '/impressum',
    element: <ImpressumPage />,
  },
  {
    path: '/datenschutz',
    element: <DatenschutzPage />,
  },
  {
    path: '/agb',
    element: <AGBPage />,
  },
  {
    path: '/danke',
    element: <DankePage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;